export const GET_EMERGENCIES_REQUEST = 'emergencies/GET_EMERGENCIES_REQUEST'
export const GET_EMERGENCIES_SUCCESS = 'emergencies/GET_EMERGENCIES_SUCCESS'
export const GET_EMERGENCIES_ERROR = 'emergencies/GET_EMERGENCIES_ERROR'

export const CREATE_EMERGENCY_REQUEST = 'emergencies/CREATE_EMERGENCY_REQUEST'
export const CREATE_EMERGENCY_SUCCESS = 'emergencies/CREATE_EMERGENCY_SUCCESS'
export const CREATE_EMERGENCY_ERROR = 'emergencies/CREATE_EMERGENCY_ERROR'
